import { render } from "./PageProfile.vue?vue&type=template&id=0ceb283a&scoped=true"
import script from "./PageProfile.vue?vue&type=script&lang=js"
export * from "./PageProfile.vue?vue&type=script&lang=js"

import "./PageProfile.vue?vue&type=style&index=0&id=0ceb283a&lang=scss&scoped=true"

import exportComponent from "/Users/adostos/wame/zealy-web-2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ceb283a"]])

export default __exports__